import React, { memo } from 'react'
import { Bullet } from 'components/atoms/icons'
import { ICustomerContact } from 'apps/fleet-planner/types'
import formatPhone from 'utils/formatPhone'

interface IFacilityContactInfoProps {
  facilityContact?: ICustomerContact
}

export const FacilityContactInfo = memo<IFacilityContactInfoProps>(({ facilityContact }) => {
  const { email, name: facilityContactName, phone, phoneExt } = facilityContact || {}

  const hasNoContactInfo: boolean = !facilityContactName && !email && !phone
  const phoneExtString = phoneExt ? `Ext. ${phoneExt}` : ``

  return (
    <div>
      <div className='b'>Facility Contact</div>
      {hasNoContactInfo && <div>No contact information</div>}
      {!hasNoContactInfo && (
        <>
          <div>{facilityContactName || 'No contact name'}</div>
          <span className='fs-mask'>
            {phone
              ? `${formatPhone(phone, { removeCountryCode: '+1' })}${
                  phoneExtString ? ` ${phoneExtString}` : ''
                }`
              : 'No phone'}
          </span>
          <Bullet />
          <span className='fs-mask'>{email || 'No email'}</span>
        </>
      )}
    </div>
  )
})
